
<div class="nav-search-panel">
    <!-- Search field menu -->
    <v-menu offset-y v-model="fieldOpen" :close-on-content-click="false" max-width="400">

        <template v-slot:activator="{ attrs, on }">
            <div class="nav-search-field" v-bind="attrs" v-on="on">
                <span>{{ field.name }}</span>
                <i class="fas fa-caret-down" :class="{'nav-search-field-open':fieldOpen}"></i>
            </div>
        </template>

        <div class="white pb-3 pt-3" v-if="fields && fields.length === 1">
            <v-list-item
                class="pa-0  pt-1 pb-1"
                v-for="fld in fields[0].fields"
                :key="fld.id"
                link
                @click="onFieldSelected(fields[0].id, fld)"
            >
                <v-list-item-title class="pl-3"  v-text="fld.name"></v-list-item-title>
            </v-list-item>
        </div>
    </v-menu>
    <!-- Search field menu -->

    <!-- Search criteria input -->
    <div class="nav-search-input">
        <label>
            <input @keypress.enter="onEnter" @focusin="onFocusIn" @focusout="onFocusOut" type="text" v-model="criteria" />
        </label>
        <div class="nav-search-icon">
            <a @click="onSearch"><i class="fas fa-search"></i></a>
        </div>
    </div>
    <!-- Search criteria input -->
</div>
